
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed, watch } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import Descriptions from '@/components/descriptionsLhl.vue'
import api from '@/api/allApi'
import Nodata from '@/components/page/nodata.vue'
import globalsets from '@/utils/globalsets'

import f10ApiHk from '@/api/f10ApiHk'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { ClockCircleOutlined, Descriptions, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      info: {},
      spinning: true
    })
    pageData.list = [
      { title: '上市日期', key: 'ipoData', align: 'left' },
      { title: '所属市场', key: 'belongMarket', align: 'left' },
      { title: '发行价（港元）', key: 'issuePrice', align: 'left' },
      { title: '发行量(股)', key: 'issueNumber', align: 'left' },
    ]

    // 格式化发行量 - 转换为千、万、亿、万亿单位
    const formatIssueNumber = (number: number) => {
      if (number === null || number === undefined) return '—'

      const absNumber = Math.abs(number)

      if (absNumber >= 1e12) {
        return (number / 1e12).toFixed(3) + '万亿'
      } else if (absNumber >= 1e8) {
        return (number / 1e8).toFixed(3) + '亿'
      } else if (absNumber >= 1e4) {
        return (number / 1e4).toFixed(3) + '万'
      } else if (absNumber >= 1e3) {
        return (number / 1e3).toFixed(3) + '千'
      } else {
        return number.toString()
      }
    }

    onMounted(() => {
      const route: any = useRoute()
      const data: any = {}
      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.code || '00700',

      }
      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }
      f10ApiHk.getBriefDetail(data).then((res: any) => {
        if (res && res.data) {
          const raw = res.data.issueInfoDetail
          // 处理后的数据
          const info: any = {
            ipoData: raw.ipoData ? window.moment(raw.ipoData).format('YYYY-MM-DD') : '—', // 上市日期
            belongMarket: raw.belongMarket || '—', // 所属市场
            issuePrice: raw.issuePrice != null ? raw.issuePrice.toFixed(2) : '—', // 发行价
            issueNumber: raw.issueNumber != null ? formatIssueNumber(raw.issueNumber) : '—', // 发行量
            orgCnIntroduction: raw.orgCnIntroduction // 公司简介
          }
          pageData.info = info
          pageData.spinning = false
          pageData.spinning = false
        }

      })


    })
    // watch(
    //   () => props.pageSourceData,
    //   () => {
    //     const _data = props.pageSourceData || {}
    //     _data.ProvinceCity = _data.Province + _data.City
    //     _data.RegCapital = _data.RegCapital = globalsets.getNumber(_data.RegCapital)
    //     pageData.info = _data
    //     nextTick(() => {
    //       pageData.spinning = false
    //     })
    //   },
    //   { deep: true }
    // )
    return {
      ...toRefs(pageData)
    }
  }
})
